import { useEffect, useState } from "react";
import MaterialTable from "material-table";
import { Box, Grid, FormControl, CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import { getImageSignedUrl } from "../../../../Base/helper/baseFunctions";
import CommonDatePicker from "../../../../Base/views/CommonDatePicker";
import { GetEmployeeExpenseCsvAction } from "../../../../../../store/Finance/Expense/Action";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { GetExpenseReportHelper } from "../../../helper/MyExpenseHelper";
import ExpenseReportPDF from "../../../helper/HelperComponents/ExpenseReport";
import { GetLetterHeadAction } from "../../../../../../store/Ancillary/LetterHead/Action";
import { toast } from "react-toastify";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";

const ExpensePayoutReport = () => {
  const dispatch = useDispatch();
  const date = new Date();
  const [isCsvLoading, setIsCsvLoading] = useState(false);
  const [filters, setFilters] = useState({
    month_year: `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()}`,
  });
  const { employee_expense_csv, employeeExpenseCsvLoading } = useSelector(
    (state) => state?.FinanceReducer?.ExpenseReducer
  );
  const { company_logo } = useSelector(
    (state) => state?.AncillaryReducer?.LetterHeadReducer
  );
  const { letterHeadData } = useSelector(
    (state) => state?.AncillaryReducer?.LetterHeadReducer
  );
  const { minDojYear } = useSelector(
    (state) => state?.AncillaryReducer?.WorkSpaceDojReducer
  );

  const handleFilter = (event) => {
    if (["month_year"].includes(event?.target?.name)) {
      const updatedFilters = {
        ...filters,
        [event?.target?.name]: event?.target?.value,
      };
      setFilters(updatedFilters);
      // Extract and set the new name
      const selectedDate = new Date(updatedFilters.month_year);
      const formattedName = selectedDate.toLocaleString("default", {
        month: "short",
        year: "numeric",
      });
      setName(formattedName);
    }
  };
  const selectedDate = new Date(filters.month_year);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [loadingviewRowId, setViewLoadingRowId] = useState(null);
  const [name, setName] = useState(
    selectedDate.toLocaleString("default", { month: "short", year: "numeric" })
  );

  const handleDownloadPDF = async (rowData) => {
    setLoadingRowId(rowData.employee_id);
    const urlImage = await getImageSignedUrl(company_logo);
    const selectedDate = new Date(filters.month_year);
    setName(
      selectedDate.toLocaleString("default", {
        month: "short",
        year: "numeric",
      })
    );
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    try {
      const res = await GetExpenseReportHelper({
        employee_fk: rowData?.employee_id,
        month: f_month,
        year: f_year,
      });

      if (res?.data?.data?.[0]) {
        const MyDocument = (
          <ExpenseReportPDF
            data={res.data.data[0]}
            imageUrl={urlImage}
            letterHeadData={letterHeadData?.[0]}
          />
        );
        const blob = await pdf(MyDocument).toBlob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${rowData?.employee_name} - ${name}.pdf`;
        a.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Error generating the PDF:", error);
    } finally {
      setLoadingRowId(null);
    }
  };
  const handleViewPaySlip = async (rowData) => {
    setViewLoadingRowId(rowData.employee_id);
    const urlImage = await getImageSignedUrl(company_logo);
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    try {
      const res = await GetExpenseReportHelper({
        employee_fk: rowData?.employee_id,
        month: f_month,
        year: f_year,
      });

      if (res?.data?.data?.[0]) {
        const MyDocument = (
          <ExpenseReportPDF
            data={res.data.data[0]}
            imageUrl={urlImage}
            letterHeadData={letterHeadData?.[0]}
          />
        );
        const blob = await pdf(MyDocument).toBlob();
        const fileName = `${rowData?.employee_name} - ${name}.pdf`;
        const file = new File([blob], fileName, { type: "application/pdf" });
        const url = URL.createObjectURL(file);
        const newWindow = window.open(url, "_blank");
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed === "undefined"
        ) {
          alert("Please allow popups for this site to view the payslip");
        }
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      setViewLoadingRowId(null);
    }
  };
  const handleExport = () => {
    setIsCsvLoading(true);
    const [f_year, month] = filters.month_year.split("-");
    try {
      const headers = [
        { label: "Employee No", key: "employee_no" },
        { label: "Name", key: "employee_name" },
        { label: "Email", key: "office_email" },
        { label: "Reimbursement Amount", key: "expenses_reimbursement" },
      ];
      const csvData = [headers.map((header) => header.label)];
      employee_expense_csv?.forEach((row) => {
        const rowData = headers.map((header) => row[header.key]);
        csvData.push(rowData);
      });
      const csv = csvData.map((row) => row.join(",")).join("\n");
      const blob = new Blob([csv], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = `Expense Report_${month}_${f_year}`;
      downloadLink.setAttribute("target", "_blank");
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(url);
    } catch (err) {
      toast.error(`Error generating CSV: ${err.message}`);
    } finally {
      setIsCsvLoading(false);
    }
  };
  useEffect(() => {
    dispatch(GetLetterHeadAction());
  }, [dispatch]);
  useEffect(() => {
    const [f_year, month] = filters.month_year.split("-");
    const f_month = parseInt(month, 10).toString();
    dispatch(
      GetEmployeeExpenseCsvAction({
        month: f_month,
        year: f_year,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters?.month_year]);
  return (
    <>
      <Box sx={{ maxHeight: "89vh", overflowY: "auto" }}>
        <Box sx={{ m: 1, mt: 2 }}>
          <Grid
            sx={{ display: "flex", justifyContent: "space-between" }}
            container
            columnSpacing={1}
            mb={1}
          >
            <FormControl>
              <CommonDatePicker
                name="month_year"
                openTo="month"
                views={["year", "month"]}
                label="Month and Year"
                pickerType="date"
                size="small"
                onKeyDown={(e) => e.preventDefault()}
                onKeyPress={(e) => e.preventDefault()}
                pickerFormat="MM/yyyy"
                DefaultDTvalue={filters.month_year}
                maxDate={new Date()}
                // minDate={new Date(minDojYear)}
                minDate={new Date(new Date(minDojYear).getFullYear() - 1, new Date(minDojYear).getMonth(), 1)} 
                handleChange={(value) =>
                  handleFilter({
                    target: {
                      name: "month_year",
                      value: value
                        ? `${value?.getFullYear()}-${(
                            "0" +
                            (value?.getMonth() + 1)
                          ).slice(-2)}-${("0" + value?.getDate()).slice(-2)}`
                        : "",
                    },
                  })
                }
              />
            </FormControl>
          </Grid>
        </Box>

        <MaterialTable
          isLoading={employeeExpenseCsvLoading}
          columns={[
            {
              title: "Name",
              cellStyle: { padding: "10px 10px 5px 13px" },
              headerStyle: { cursor: "pointer" },
              field: "employee_name",
              grouping: false,
            },
            {
              title: "Email",
              cellStyle: { padding: "10px 10px 5px 13px" },
              headerStyle: { cursor: "pointer" },
              field: "office_email",
              grouping: false,
            },
            {
              title: "Reimbursement Amount",
              cellStyle: { padding: "10px 10px 5px 13px" },
              headerStyle: { cursor: "pointer" },
              field: "expenses_reimbursement",
              grouping: false,
            },
            {
              title: "View Report",
              field: "employee_no",
              sorting: false,
              headerStyle: { textAlign: "left", cursor: "default" },
              cellStyle: { padding: "10px 10px 5px 35px", textAlign: "left" },
              render: (rowData) => {
                return loadingviewRowId === rowData.employee_id ? (
                  <CircularProgress disableShrink size={20} />
                ) : (
                  <VisibilityIcon
                    sx={{ cursor: "pointer", color: "#637381" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewPaySlip(rowData);
                    }}
                  />
                );
              },
            },
            {
              title: "Download Report",
              field: "employee_no",
              sorting: false,
              headerStyle: { textAlign: "left", cursor: "default" },
              cellStyle: { padding: "10px 10px 5px 45px", textAlign: "left" },
              render: (rowData) => {
                return loadingRowId === rowData.employee_id ? (
                  <CircularProgress disableShrink size={20} />
                ) : (
                  <CloudDownloadOutlinedIcon
                    sx={{ cursor: "pointer", color: "#637381" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDownloadPDF(rowData);
                    }}
                  />
                );
              },
            },
          ]}
          data={employee_expense_csv || []}
          options={{
            maxBodyHeight: "50vh",
            minBodyHeight: "50vh",
            rowStyle: { fontSize: "13px" },
            headerStyle: { padding: "10px 10px 5px 13px", fontWeight: "bold" },
            sorting: true,
            search: true,
            searchText: "",
            searchFieldAlignment: "right",
            searchAutoFocus: true,
            searchFieldVariant: "standard",
            filtering: false,
            paging: true,
            pageSizeOptions: [25, 50],
            pageSize: 25,
            paginationType: "stepped",
            showFirstLastPageButtons: false,
            paginationPosition: "bottom",
            exportButton: false,
            exportAllData: false,
            exportFileName: "",
            addRowPosition: "first",
            selection: false,
            actionsColumnIndex: -1,
            showSelectAllCheckbox: true,
            showTextRowsSelected: true,
            grouping: false,
            columnsButton: false,
          }}
          actions={[
            {
              icon: () =>
                isCsvLoading ? (
                  <CircularProgress size={24} />
                ) : (
                  <CloudDownloadIcon />
                ),
              tooltip: "Export CSV",
              isFreeAction: true,
              onClick: handleExport,
            },
          ]}
          title="Employees"
        />
      </Box>
    </>
  );
};

export default ExpensePayoutReport;
